import Button from '@/common/components/base/button/Button';
import MainModal from '@/common/components/base/modal/Modal';
import { MainModalProps } from '@/common/components/base/modal/Modal.type';
import SignatureDrawingPad from '@/common/components/base/signatureCanvas/instances/SignatureDrawingPad';
import TitleDescription from '@/common/components/base/typography/TitleDescription';
import Typography from '@/common/components/base/typography/Typography';
import FixToBottom from '@/common/components/layouts/FixToBottom';
import useSignature from '@/common/hooks/useSignature';
import { FileFaEnum } from '@/modules/adjusterReportModules/components/SignatureView/SignatureView.type';
import { Box } from 'styled-system/jsx';

const SignatureEditModalWrapper = ({
  closeModal,
  open,
  type,
  signatureProps,
  onOpenConfirmation,
}: MainModalProps & {
  type: keyof typeof FileFaEnum;

  signatureProps: ReturnType<typeof useSignature>;
  onOpenConfirmation: () => void;
}) => {
  return (
    <MainModal clipOverflow height="70vh" closeModal={closeModal} open={open}>
      <SignaturePreviewModal
        signatureProps={signatureProps}
        onOpenConfirmation={onOpenConfirmation}
        type={type}
      />
    </MainModal>
  );
};

export default SignatureEditModalWrapper;

const SignaturePreviewModal = ({
  onOpenConfirmation,
  signatureProps,
  type,
}: {
  type: keyof typeof FileFaEnum;
  signatureProps: ReturnType<typeof useSignature>;
  onOpenConfirmation: () => void;
}) => {
  return (
    <Box>
      <TitleDescription>ویرایش امضا</TitleDescription>
      <Box
        border="1px solid"
        borderColor="gray-2"
        borderRadius="10px"
        p={10}
        my="1.5rem"
        backgroundColor="white"
      >
        <>
          <Typography textStyle="b2" color="black-1" mt="1.5rem">
            {` کارشناس محترم ، از ${FileFaEnum[type]} بخواهید امضای خود را در کادر زیر ترسیم کند.`}
          </Typography>

          <SignatureDrawingPad {...signatureProps} />

          <FixToBottom>
            <Button
              onClick={onOpenConfirmation}
              disabled={signatureProps.isEmpty}
              fullWidth
            >
              ثبت
            </Button>
          </FixToBottom>
        </>
      </Box>
    </Box>
  );
};
